import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { DynamicMapElementPropertiesEditorTemplate, LabelInput } from './DynamicMapElementPropertiesSharedElements';
import { NPCSensorTriggersPropertiesEditor } from "./NPCSensorTriggersPropertiesEditor";
import { Direction } from '../../../shared/resources/DirectionHelper';
export const DynamicMapElementNPCPropertiesEditor = observer(({
  element,
  mapEditorStore
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(DynamicMapElementPropertiesEditorTemplate, {
    element: element,
    mapEditorStore: mapEditorStore,
    elementTypeKey:
    /*t*/
    "editor.editor_display_type_npc"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.isInteractionTrigger,
    onChange: () => element.setIsInteractionTrigger(!element.isInteractionTrigger)
  }), "\xA0", t("editor.element_is_interaction_trigger")))), element.isInteractionTrigger && !mapEditorStore.currentMapStore.isCurrentMapPartOfTheModule && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.isModuleGate,
    onChange: () => element.setIsModuleGate(!element.isModuleGate)
  }), "\xA0", t("editor.element_is_module_gate_interaction_trigger")))), /*#__PURE__*/React.createElement(LabelInput, {
    element: element,
    allElements: mapEditorStore.currentMapStore.currentMap.npcs,
    alreadyUsedWarningLabelKey:
    /*t*/
    "editor.warning_npc_label_already_used",
    onChange: value => element.setLabel(value)
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.element_initial_facing_direction"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("select", {
    value: element.initialFacingDirection,
    onChange: ({
      target
    }) => element.setInitialFacingDirection(+target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: Direction.East
  }, "\uD83E\uDC66 ", t("editor.direction_east")), /*#__PURE__*/React.createElement("option", {
    value: Direction.South
  }, "\uD83E\uDC67 ", t("editor.direction_south")), /*#__PURE__*/React.createElement("option", {
    value: Direction.West
  }, "\uD83E\uDC64 ", t("editor.direction_west")), /*#__PURE__*/React.createElement("option", {
    value: Direction.North
  }, "\uD83E\uDC65 ", t("editor.direction_north"))))))), /*#__PURE__*/React.createElement(NPCSensorTriggersPropertiesEditor, {
    npc: element,
    isCurrentMapPartOfTheModule: mapEditorStore.currentMapStore.isCurrentMapPartOfTheModule
  }));
});